module.exports = __webpack_public_path__ + "static/media/arrow-u-down-left.051fb450.svg";